import { IconButton, icons, Stack, Typography } from "@hiver/hiver-ui-kit";
import React from "react";
import SVGInline from "react-svg-inline";
import ResetIcon from "../../../images/reset.svg";

const FilterPanelHeader = ({ onClose, onReset }) => {
  return (
    <Stack
      direction="row"
      sx={{ gap: 1, alignItems: "center", marginBottom: 3 }}
    >
      <IconButton onClick={onClose} sx={{ p: 0 }}>
        <icons.Close sx={{ height: "15px", width: "15px" }} />
      </IconButton>
      <Typography variant="h5">Filters</Typography>
      <IconButton
        onClick={onReset}
        sx={{
          padding: "0px 8px",
          marginLeft: "auto",
          "& .SVGInline-svg": {
            paddingBottom: "4px",
            height: "15px",
            width: "15px",
          },
        }}
      >
        <SVGInline svg={ResetIcon} />
      </IconButton>
    </Stack>
  );
};

export default FilterPanelHeader;
